import { BENI_COMPARISON_SETS } from 'frontend-utils/utils/constants/benchmark-insight';
import {
  BENI_COLUMN_DATA_TYPE,
  BREAKDOWNS,
} from 'lumen/utils/constants/benchmark-insight/beni-constant-values';
import { BENI_TABLE_COLUMN_FORMATS } from 'lumen/utils/constants/benchmark-insight/beni-table-constant-values';
import { DATE_AGGREGATION } from 'lumen/utils/constants/general-constants';

export const BENI_TABLE_COLUMN_WIDTHS = {
  [BREAKDOWNS.STAY_DATE]: {
    [DATE_AGGREGATION.DAY]: {
      de: '130',
      es: '110',
      fr: '95',
      en: '95',
      ja: '80',
      pt: '120',
      it: '140',
    },
    [DATE_AGGREGATION.WEEK]: {
      fr: '210',
      en: '190',
      es: '205',
      de: '210',
      ja: '175',
      pt: '205',
      it: '220',
    } as const,
  } as const,
  [BREAKDOWNS.SEGMENT]: {
    en: '217',
    ja: '225',
    fr: '257',
    es: '227',
    de: '237',
    pt: '230',
    it: '310',
  },
  [BREAKDOWNS.LENGTH_OF_STAY]: {
    en: '217',
    ja: '225',
    fr: '257',
    es: '227',
    de: '237',
    pt: '230',
    it: '310',
  },
  [BREAKDOWNS.CHANNEL]: {
    en: '217',
    ja: '225',
    fr: '257',
    es: '227',
    de: '237',
    pt: '230',
    it: '310',
  },
  KPIS: {
    [BENI_COMPARISON_SETS.OWN]: 70,
    [BENI_TABLE_COLUMN_FORMATS.INDEX]: 50,
    [BENI_COLUMN_DATA_TYPE.PICKUP]: 65,
    [BENI_COLUMN_DATA_TYPE.REFERENCE]: 60,
    [BENI_COLUMN_DATA_TYPE.DIFFERENCE]: {
      [BENI_COMPARISON_SETS.MARKET]: 150,
      [BENI_COMPARISON_SETS.MARKET_COLLAPSED_CLASS]: 185,
      [BENI_COMPARISON_SETS.MARKET_CLASS]: 210,
      [BENI_COMPARISON_SETS.COMPSET]: 160,
      [BENI_COMPARISON_SETS.INTERNAL_COMPSET]: 205,
      [BENI_COMPARISON_SETS.SMART_COMPSET]: 195,
      [BENI_COMPARISON_SETS.RADIUS]: 200,
    },
    [BENI_COMPARISON_SETS.MARKET]: 60,
    [BENI_COMPARISON_SETS.COMPSET]: 70,
    [BENI_COMPARISON_SETS.MARKET_COLLAPSED_CLASS]: 95,
    [BENI_COMPARISON_SETS.MARKET_CLASS]: 95,
    [BENI_COMPARISON_SETS.INTERNAL_COMPSET]: 120,
    [BENI_COMPARISON_SETS.SMART_COMPSET]: 110,
    [BENI_COMPARISON_SETS.RADIUS]: 110,
  } as const,
} as const;
